import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/Locations'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LocationsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LocationsStore",
			variables: false,
		})
	}
}

export async function load_Locations(params) {
  await initClient()

	const store = new LocationsStore()

	await store.fetch(params)

	return {
		Locations: store,
	}
}
